"use strict";

exports.__esModule = true;
var _AuditLogListScreen = require("./AuditLogListScreen");
Object.keys(_AuditLogListScreen).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _AuditLogListScreen[key]) return;
  exports[key] = _AuditLogListScreen[key];
});